import React from 'react'

const XIcon = () => {
	return (
		<svg width={16} height={16} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M8 9.416L1.636 15.78.222 14.366l6.364-6.364L.222 1.638 1.636.223 8 6.587 14.364.223l1.414 1.415-6.364 6.364 6.364 6.364-1.414 1.414L8 9.416z'
				fill='currentColor'
			/>
		</svg>
	)
}

export default XIcon
